
export const baseMaps = {
  "osm-light": {
    name: 'Geobox Light Map',
    url: [
      'https://api.geobox.ir/v1/maps/f9eef3e0-5b21-4ba7-9f81-e32f9614bc90/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
    ],
    proxyUrl:
      'https://api.geobox.ir/v1/maps/f9eef3e0-5b21-4ba7-9f81-e32f9614bc90/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
  },
  "osm-dark": {
    name: 'Geobox Dark Map',
    url: [
      'https://api.geobox.ir/v1/maps/fc59bd64-6af2-4e51-a4b8-5fe0b8d4257b/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
    ],
    proxyUrl:
      'https://api.geobox.ir/v1/maps/fc59bd64-6af2-4e51-a4b8-5fe0b8d4257b/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
  },
  "osm-standard": {
    name: 'Geobox Standard Map',
    url: ['https://api.geobox.ir/v1/maps/18b3c0ec-5a41-4c69-ba72-943b8f389d7a/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg'],
    proxyUrl:
      'https://api.geobox.ir/v1/maps/18b3c0ec-5a41-4c69-ba72-943b8f389d7a/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
  },
  "osm-night": {
    name: 'Geobox Night Map',
    url: [
      'https://api.geobox.ir/v1/maps/f8c8ce92-3847-44b8-82ef-cf919915f161/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
    ],
    proxyUrl:
      'https://api.geobox.ir/v1/maps/f8c8ce92-3847-44b8-82ef-cf919915f161/tiles/{z}/{x}/{y}.png?apikey=QiFeeRwWE6uylDnnkn3nlDQi-3yn-NiRoexrRXrvlBg',
  },
  "osm": {
    name: 'OSM Map',
    url: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
    proxyUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  },
  "google": {
    name: 'Google Satellite Map',
    url: ['https://www.google.com/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}'],
    proxyUrl:
      'https://www.google.com/maps/vt?lyrs=s@189%26gl=cn%26x={x}%26y={y}%26z={z}',
  },
  "google-hybrid": {
    name: 'Google Satellite Hybrid Map',
    url: ['https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'],
    proxyUrl: 'https://mt1.google.com/vt/lyrs=y%26x={x}%26y={y}%26z={z}',
  },
  "blank": {
    name: 'blank',
    url: [''],
    proxyUrl: '',
  },
};
